import { withApollo } from "react-apollo";
import React from "react";
import { SET_TIMEOUT_VALUE } from "../../../constants/app-constants";
import DisplayErrors from "../../Common/DisplayErrors";
import { redirectTo } from "../../../util/redirect";
import { addRoleQuery } from "../../../services/graphql/queries/roles";
import ReactModal from "../../Common/ReactModal";
import { alphanumericAcceptanceValidation } from "../../../miscellaneous/misc";
import {
  UNDERSCORE,
  ALPHANUMERIC_NAME_VALIDATION
} from "../../../constants/app-constants";
import { withRouter } from "react-router-dom";

class RolesAdd extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      nameErr: false,
      description: "",
      descriptionErr: false,
      errorMsg: "",
      errors: [],
      reactModalVisible: false,
      requireCancel: false,
      modalMessage: "Created Successfully",
      userId: "",
      isSubmitDisable: false,
      entityType: "",
      entityTypeErr: false
    };

    this.resetForm = this.resetForm.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.submitModal = this.submitModal.bind(this);
  }

  componentDidMount() {
    this.initialState = this.state;
  }

  resetForm() {
    this.setState({
      name: "",
      nameErr: false,
      description: "",
      descriptionErr: false,
      entityType: "",
      entityTypeErr: false,
      errors: []
    });
    // this.setState({ ...this.initialState });
  }

  submitForm(e) {
    //Use below variables to Update DB via GraphQL after all validations pass

    const { name, description, emailId, mobileNumber, entityType } = this.state;

    this.setState({ errors: [] });
    e.preventDefault();

    if (!name) {
      this.state.nameErr = "*Enter a valid role name";
    } else if (!alphanumericAcceptanceValidation(name, UNDERSCORE)) {
      this.state.nameErr =
        "* Role Name must start with a character and can contain alphanumeric and _ ";
    } else if (name.length < 5) {
      this.state.nameErr = "* Role Name must contain minimum 5 characters";
    } else {
      this.state.nameErr = "";
    }

    if (description == "") {
      this.state.descriptionErr = "*Enter Valid description";
    } else if (
      !alphanumericAcceptanceValidation(
        description,
        ALPHANUMERIC_NAME_VALIDATION
      )
    ) {
      this.state.descriptionErr =
        "Description must start with a character and can contain alphanumeric and &, _, / ";
    } else {
      this.state.descriptionErr = "";
    }

    if (entityType == "") {
      this.state.entityTypeErr = "*Select a valid Entity type";
    } else {
      this.state.entityTypeErr = "";
    }

    if (
      this.state.nameErr != "" ||
      this.state.descriptionErr != "" ||
      this.state.entityTypeErr != ""
    ) {
      return;
    }

    this.setState({ isSubmitDisable: true });
    this.props.client
      .mutate({
        mutation: addRoleQuery,
        variables: {
          roleName: this.state.name,
          description: this.state.description,
          entityType: parseInt(this.state.entityType)
        },
        fetchPolicy: "no-cache"
      })
      .then(result => {
        this.setState({
          reactModalVisible: true,
          userId: result.data.addRole.roles.Id,
          isSubmitDisable: false
        });
      })
      .catch(error => {
        console.log("~~~error: ", error);
        this.setState({ isSubmitDisable: false });
        error.graphQLErrors.map(({ message }, i) => {
          this.setState(prevState => {
            return { errors: [message] };
          });
        });
        setTimeout(() => {
          this.setState({ errors: [] });
        }, SET_TIMEOUT_VALUE);
      });
  }

  submitModal() {
    this.setState({ reactModalVisible: false });
    // redirectTo("/roles-profile?id=" + this.state.userId);
    this.props.history.push("/roles-profile?id=" + this.state.userId);
  }

  render() {
    const {
      name,
      nameErr,
      description,
      descriptionErr,
      errors,
      reactModalVisible,
      requireCancel,
      modalMessage,
      isSubmitDisable,
      entityTypeErr,
      entityType
    } = this.state;
    return (
      <div>
        <ReactModal
          reactModalVisible={reactModalVisible}
          submitModal={this.submitModal}
          modalMessage={modalMessage}
          requireCancel={requireCancel}
        />
        <h1 className="heading m-b-25">New Role</h1>
        <div
          className="row"
          style={{
            display: errors.length === 0 ? "none" : "block"
          }}
        >
          <div className="col-md-6">
            <div className="alert alert-success" role="alert">
              <div className="row">
                <DisplayErrors errors={errors} />
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="box-card">
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>ROLE NAME</label>
                    <span style={{ color: "#ff0000", fontSize: "16px" }}>
                      *
                    </span>
                    <input
                      type="text"
                      className={
                        "form-control " + (nameErr ? "is-invalid" : "")
                      }
                      placeholder="Enter Role Name"
                      value={name}
                      maxLength={20}
                      onChange={e => {
                        this.setState({ name: e.target.value });
                      }}
                    />
                    {nameErr ? (
                      <div className="invalid-feedback">
                        {this.state.nameErr}
                      </div>
                    ) : null}
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="form-group">
                    <label>ENTITY TYPE</label>
                    <span style={{ color: "#ff0000", fontSize: "16px" }}>
                      *
                    </span>

                    <select
                      className="form-control light-green select-style-1"
                      value={entityType}
                      onChange={e => {
                        this.setState({ entityType: e.target.value });
                      }}
                    >
                      <option value={""}>Select</option>
                      <option value={1}> Investor </option>
                      <option value={2}> User</option>
                      {/* <option value={3}>Installing Company</option> */}
                      {/* <option value={4}>Installer</option> */}
                      {/* <option value={5}>Customer</option> */}
                    </select>
                    {entityTypeErr ? (
                      <div
                        className="invalid-feedback"
                        style={{ display: "block" }}
                      >
                        {entityTypeErr}
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>DESCRIPTION</label>
                    <span style={{ color: "#ff0000", fontSize: "16px" }}>
                      *
                    </span>
                    <input
                      type="text"
                      className={
                        "form-control " + (descriptionErr ? "is-invalid" : "")
                      }
                      placeholder="Enter Description"
                      value={description}
                      maxLength={40}
                      onChange={e => {
                        this.setState({ description: e.target.value });
                      }}
                    />
                    {descriptionErr ? (
                      <div className="invalid-feedback">
                        {this.state.descriptionErr}
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 col-lg-5">
                  <button
                    type="button"
                    className="btn btn-danger "
                    onClick={e => this.submitForm(e)}
                    disabled={isSubmitDisable}
                  >
                    Submit
                  </button>
                  <button
                    type="button"
                    className="btn btn-light m-l-50"
                    onClick={this.resetForm}
                  >
                    Clear
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(withApollo(RolesAdd));
